import { render, staticRenderFns } from "./PurchaseOrderMenu.vue?vue&type=template&id=35581e49&scoped=true"
import script from "./PurchaseOrderMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMenu.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderMenu.vue?vue&type=style&index=0&id=35581e49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35581e49",
  null
  
)

export default component.exports